import React from "react";
import styles from "./AppRequirements.module.scss";
import { connect } from "react-redux";

function AppRequirements({app, currentPlan, plans}) {

    const plan = !currentPlan?.supportedFeatures?.includes(app.category?.[0]?.name)
        ? plans.find(p => p.supportedFeatures.includes(app.category?.[0]?.name))
        : null;

    // console.log(!currentPlan?.supportedFeatures?.includes(app.type))
    // console.log(app.plan_type)

    return (
        <div className={styles.req}>
            <div className={styles.req__item}>
                <i className='fas fa-microchip'/>
                <p>CPU {app.cpu || '0'}</p>
            </div>
            <div className={styles.req__item}>
                <i className='fas fa-memory'/>
                <p>RAM {app.ram_size || '0Gb'}</p>
            </div>
            <div className={styles.req__item}>
                <i className='fas fa-hdd'/>
                <p>Storage {app.disk_size || '0Gb'}</p>
            </div>
            {
                !!plan &&
                <div className={styles.req__plan}>
                    <i className='fas fa-shopping-cart'/>
                    <p>{plan.name}</p>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => ({
    // bodyStack: state.deployment.bodyStack,
    // features: state.deployment.featuresData.features,
    // dependencies: state.deployment.featuresData.dependencies,
    plans: state.commonData.plans,
    currentPlan: state.userData.currentPlan,
});

export default connect(mapStateToProps)(AppRequirements)